import { Link } from 'react-router-dom';

export function AuthorizationDashboardPage() {
  return (
    <div className="mx-auto max-w-4xl p-6">
      <h1 className="text-2xl font-semibold text-slate-900">Authorization dashboard</h1>
      <p className="mt-1 text-sm text-slate-600">Manage RBAC roles, permissions, ABAC policies, and audit access decisions.</p>
      <nav className="mt-8 grid gap-4 sm:grid-cols-2">
        <Link to="/authorization/roles" className="rounded-xl border border-slate-200 bg-white p-5 hover:border-slate-400">
          <p className="font-medium text-slate-900">Role management</p>
          <p className="mt-1 text-sm text-slate-600">Create roles and configure role hierarchy.</p>
        </Link>
        <Link to="/authorization/permissions" className="rounded-xl border border-slate-200 bg-white p-5 hover:border-slate-400">
          <p className="font-medium text-slate-900">Permission catalogue</p>
          <p className="mt-1 text-sm text-slate-600">Define resource:action permissions.</p>
        </Link>
        <Link to="/authorization/matrix" className="rounded-xl border border-slate-200 bg-white p-5 hover:border-slate-400">
          <p className="font-medium text-slate-900">Permission matrix</p>
          <p className="mt-1 text-sm text-slate-600">View role × permission assignments.</p>
        </Link>
        <Link to="/authorization/policies/builder" className="rounded-xl border border-slate-200 bg-white p-5 hover:border-slate-400">
          <p className="font-medium text-slate-900">Policy builder</p>
          <p className="mt-1 text-sm text-slate-600">Create ABAC allow/deny policies with conditions.</p>
        </Link>
        <Link to="/authorization/assignments" className="rounded-xl border border-slate-200 bg-white p-5 hover:border-slate-400">
          <p className="font-medium text-slate-900">Role assignment</p>
          <p className="mt-1 text-sm text-slate-600">Assign roles to users.</p>
        </Link>
        <Link to="/authorization/me" className="rounded-xl border border-slate-200 bg-white p-5 hover:border-slate-400">
          <p className="font-medium text-slate-900">My permissions</p>
          <p className="mt-1 text-sm text-slate-600">Effective permissions for your identity.</p>
        </Link>
        <Link to="/authorization/audit" className="rounded-xl border border-slate-200 bg-white p-5 hover:border-slate-400 sm:col-span-2">
          <p className="font-medium text-slate-900">Permission audit</p>
          <p className="mt-1 text-sm text-slate-600">Review authorization checks and administrative changes.</p>
        </Link>
      </nav>
    </div>
  );
}
